import { useEffect, useState } from "react";
import axios from "axios";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Alert,
  CircularProgress,
} from "@mui/material";

export default function DistributeUrlsDialog({
  open,
  onClose,
  group,
  onSuccess,
}) {
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [loading, setLoading] = useState(false);

  console.log("group", group);
  console.log("selectedGroup", selectedGroup);

  useEffect(() => {
    if (!open || !group) return;

    fetchGroups();
  }, [open, group]);

  const fetchGroups = async () => {
    try {
      const { data } = await axios.get(
        "/api/v1/sitemap/groups",
        {
          source: group.source,
          type: group.type,
        }
      );

      setGroups(
        data.data.filter((g) =>  g.type == group.type && g.url_count < g.chunk_size)
      );
    } catch (err) {
      console.log(err);
    }
  };

    const handleAssign = async () => {
    if (!selectedGroup) return;

    try {
        setLoading(true);

        await axios.post(
        "/api/v1/sitemap/groups/assign",
        {
            source_group_id: group.id,
            destination_group_id: selectedGroup,
        }
        );

        onSuccess?.();
        onClose();

    } catch (err) {
        console.log(err);
    } finally {
        setLoading(false);
    }
    };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        Distribute Sitemap URLs
      </DialogTitle>

      <DialogContent>

        <Alert severity="warning" sx={{ mb: 3 }}>
          This sitemap contains more URLs than the
          configured limit. Select another sitemap
          group to move the next available URLs.
        </Alert>

        <Typography
          fontWeight={600}
          mb={1}
        >
          Current Group
        </Typography>

        <Box mb={3}>
          <Typography>
            {group?.name}
          </Typography>

          <Typography
            variant="body2"
            color="text.secondary"
          >
            {group?.url_count} URLs
          </Typography>
        </Box>

        <FormControl fullWidth>

          <InputLabel>
            Destination Group
          </InputLabel>

<Select
  value={selectedGroup}
  label="Destination Group"
  onChange={(e) => setSelectedGroup(e.target.value)}
>
  {groups.length > 0 ? (
    groups.map((g) => (
      <MenuItem
        key={g.id}
        value={g.id}
        disabled={g.url_count >= g.chunk_size}
      >
        {g.name} ({g.url_count}/{g.chunk_size})
      </MenuItem>
    ))
  ) : (
    <MenuItem disabled>
      No available groups. Create a new sitemap group.
    </MenuItem>
  )}
</Select>

        </FormControl>

      </DialogContent>

      <DialogActions>

        <Button onClick={onClose}>
          Cancel
        </Button>

        <Button
          variant="contained"
          disabled={
            !selectedGroup || loading
          }
          onClick={handleAssign}
        >
          {loading ? (
            <CircularProgress
              size={18}
              color="inherit"
            />
          ) : (
            "Assign URLs"
          )}
        </Button>

      </DialogActions>
    </Dialog>
  );
}